












import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import { ProfileStubState } from './BuilderProfile.vue'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderButton,
    BuilderTooltip,
    BuilderDot
  },
  computed: {
    ...mapGetters('builder', { app: 'getApp'}),
  },
})
export default class BuilderProfileDomainName extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: ProfileStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  async onNextClick(): Promise<void> {
    this.$emit('next')
  }

  async mounted(): Promise<void> {
    this.$emit('input', {
      highlight: 'domain',
      blurProfile: true,
      blurCover: true,
      blurSubscriptions: true,
      blurContentType: true,
      blurPosts: true
    })
  }
}
